import ProductDetails from "../ProductDetails/ProductDetails";
import scrollToElement from "../../utils/scrollToElement";

// ---- Constants ----
// viewport width where mobile-desktop layout change happens
const bpValue = 768;

var init = function() {
  var productSpecificationsButton = document.getElementById("js-pdp-main-open--product-specs");

  if (productSpecificationsButton != undefined) {
    productSpecificationsButton.onclick = handleAnchorToDetailBlock;
  }
};

/**
 * @name handleAnchorToDetailBlock
 * @summary
 * click handler for anchros to detail block.
 * @function
 * click handler for anchors to detail block.
 * Will have a different behavior depending on the viewport width.
 * This function was made since there are currently 2 types of anchor links
 * in the main block.
 *
 * @param {Event} e event that gets passed into the function
 */
var handleAnchorToDetailBlock = function(e) {
  e.preventDefault();


  var self = e.currentTarget;
  var tabId = self.getAttribute("data-tab-id");

  openDetailSection(tabId);
  // if layout is desktop, do a scroll
  if (window.innerWidth >= bpValue) {
    var targetElement = document.getElementById(tabId);

    scrollToElement(targetElement);
  }
};


/**
 * @name openDetailDrawer
 * @function
 * function wrapper for opening mobile drawer.
 * Wrapped the module function in case there's a change in how detail drawer
 * is opened in the future.
 *
 * @param {String} tabId - the element id of the tab that is going to be opened
 */
var openDetailSection = function(tabId) {
  ProductDetails.switchTab(tabId);
};

export default {init, handleAnchorToDetailBlock};
